import * as log from 'loglevel';
import * as ko from 'knockout';
import {UiVoiceoverData} from './VoiceOverData';
import {forIn} from 'lodash';
import {game} from '../../game/GameCore';
import {toggleMute, playSound} from '../../game/audio/AudioManager';

interface ISfxData
{
    start: number;
    length: number;
}

var uiSfx: Phaser.Sound,
    quizSfx: Phaser.Sound;



/**
 * register voiceover sprites with Phaser
 */
export function registerUiSfx()
{
    //  create the sound sprite object

    uiSfx = game.add.audio('ui-sfx');
    uiSfx.allowMultiple = true;

    //  register each unique VO as an effect that we can play individually

    forIn(UiVoiceoverData, (sfx: ISfxData, key: string) =>
    {
        //log.debug('adding VO', key, sfx.start, sfx.length);

        uiSfx.addMarker(key, sfx.start, sfx.length);
    });

    //setTimeout(() => playUiVoiceover('main-menu--play'), 3500);
}


/**
 * play a UI voiceover
 * @param id
 */
export function playUiVoiceover(id: string, delay: number = 0)
{
    game.sound.stopAll();

    try
    {
        setTimeout(() => uiSfx.play(id), delay);

    }
    catch(e)
    {}
}


// WEBPACK FOOTER //
// ./src/ts/audio/voiceovers/VoiceOverManager.ts